<template>
  <div class="h-full mx-auto flex justify-center items-center bg-gray-400">
    <div class="bg-white shadow-lg">
        <div class="bg-red-500 p-4 px-8 shadow text-white text-2xl font-semibold">Praksispoolen</div>
        <div class="py-10 px-20">
          <div class="text-center text-3xl font-bold mb-12">
            Nullstill passord
          </div>
          <template v-if="!isSent">
            <form @submit.prevent="onSubmit">
              <div class="flex items-center justify-between">
                <label for="email" class="font-bold">E-post</label>
                <input type="text" name="email" id="email" autocomplete v-model="email" ref="email" required class="ml-6 w-64">
              </div>
              <div class="p-4 mt-12 bg-red-100 border-2 border-red-300 rounded-lg text-center shadow-lg w-64 mx-auto" v-show="errorMessage">
                {{ errorMessage }}
              </div>
              <div class="text-center mt-12">
                <router-link class="btn" to="/">Avbryt</router-link>
                <button type="submit" class="btn btn-primary ml-2">
                  <div class="flex items-center">
                    <font-awesome-icon :icon="['far', 'envelope']"/>
                    <div class="ml-2">Send</div>
                  </div>
                </button>
              </div>
            </form>
        </template>
        <template v-else>
          Vi har nå sendt deg en e-post med en lenke som tar deg til en side der du kan angi nytt passord.
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'reset-password',
  data () {
    return {
      isSent: false,
      errorMessage: null,
      email: ''
    }
  },
  methods: {
    async onSubmit () {
      const response = await api.resetPassword(this.email)
      if (response.status === 400) {
        this.errorMessage = 'Ukjent e-post adresse.'
      } else {
        this.isSent = true
      }
    }
  },

  mounted () {
    this.email = this.$router.currentRoute.query.email
    this.$nextTick(() => {
      this.$refs.email.focus()
    })
  }
}
</script>

